import { render, staticRenderFns } from "./MoreActionsMenu.vue?vue&type=template&id=32191010&scoped=true"
import script from "./MoreActionsMenu.vue?vue&type=script&lang=js"
export * from "./MoreActionsMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32191010",
  null
  
)

export default component.exports